import Script from 'next/script';
import {memo} from 'react';

const CancelAppLoading = () => (
    <Script id="cancelAppLoading" strategy="beforeInteractive">
        {`var notifyPageHideLoading = {
            callbackId: 'INVALID',
            service: 'gtpage',
            action: 'notifyPage',
            args: [{
                loading: {
                    show: '0'
                }
            }]
        };
        var isGaotuIos = /gaotuapp-ios/i.test(navigator.userAgent);
        var isGaotuAndroid = /gaotuapp-android/i.test(navigator.userAgent);
        var isNoah = /noah/i.test(navigator.userAgent);
        function fastNoahExec (callbackId, service, action, args) {
            if (isGaotuIos && isNoah) {
                try {
                    window.webkit.messageHandlers.noah.postMessage([callbackId, service, action, args]);
                } catch (e) {
                    console.error('fastNoahExec  window.webkit.messageHandlers.noah', e);
                }
            } else if (isGaotuAndroid && isNoah) {
                try {
                    window._noahNative.exec(-1000, service, action, callbackId, JSON.stringify(args));
                } catch (e) {
                    console.error('fastNoahExec  window._noahNative', e);
                }
            }
        }
        fastNoahExec(notifyPageHideLoading.callbackId, notifyPageHideLoading.service, notifyPageHideLoading.action, notifyPageHideLoading.args)`}
    </Script>
);

export default memo(CancelAppLoading);
